import { useSelector }                            from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import FourFour                                   from './pages/404/404'
import Login                                      from './pages/auth/Login'
import PasswordReset                              from './pages/auth/PasswordReset'
import BmPlatform                                 from './pages/BmPlatform/BmPlatform'
import BmPlatformFaq                              from './pages/BmPlatform/BmPlatformFaq'
import BmPlatformHelpCentre                       from './pages/BmPlatform/BmPlatformHelpCentre'
import DesignDock                                 from './pages/DesignDock/DesignDock'
import DesignDockError                            from './pages/DesignDock/DesignDockError'
import Documents                                  from './pages/Documents'
import { DocumentsDownloadLog }                   from './pages/Downloads'
import CommunityForum                             from './pages/Forum/CommunityForum'
import CommunityForumEditThread                   from './pages/Forum/CommunityForumEditThread'
import CommunityForumNewThread                    from './pages/Forum/CommunityForumNewThread'
import CommunityForumThread                       from './pages/Forum/CommunityForumThread'
import Home                                       from './pages/Home'
import HowToVideos                                from './pages/HowToVideos/HowToVideos'
import Locations                                  from './pages/Locations/Locations'
import LocationsAdd                               from './pages/Locations/LocationsAdd'
import LocationsEdit                              from './pages/Locations/LocationsEdit'
import NewSeniorLeaderNotification                from './pages/NewSeniorLeaderNotification/NewSeniorLeaderNotification'
import NurserySupport                             from './pages/NurserySupport/NurserySupport'
import RegulatoryBodyNotificationForm             from './pages/RegulatoryBodyNotificationForm/RegulatoryBodyNotificationForm'
import SettingsForumCategories                    from './pages/Settings/ForumSettings/SettingsForumCategories'
import SettingsForumRank                          from './pages/Settings/ForumSettings/SettingsForumRank'
import SettingsForumRanks                         from './pages/Settings/ForumSettings/SettingsForumRanks'
import Settings                                   from './pages/Settings/Settings'
import SettingsDashboardBanner                    from './pages/Settings/GeneralSettings/SettingsDashboardBanner'
import SettingsShopCategories                     from './pages/Settings/ShopSettings/SettingsShopCategories'
import SettingsShopDeliveryOption                 from './pages/Settings/ShopSettings/SettingsShopDeliveryOption'
import SettingsShopDeliveryOptionsList            from './pages/Settings/ShopSettings/SettingsShopDeliveryOptionsList'
import SettingsShopProduct                        from './pages/Settings/ShopSettings/SettingsShopProduct'
import SettingsShopProductsList                   from './pages/Settings/ShopSettings/SettingsShopProductsList'
import SettingsShopSizeGuide                      from './pages/Settings/ShopSettings/SettingsShopSizeGuide'
import SettingsShopSizeGuidesList                 from './pages/Settings/ShopSettings/SettingsShopSizeGuidesList'
import SettingsShopVariants                       from './pages/Settings/ShopSettings/SettingsShopVariants'
import SettingsShopVariantsVariations             from './pages/Settings/ShopSettings/SettingsShopVariantsVariations'
import SettingsUsersAccountTypes                  from './pages/Settings/UsersSettings/SettingsUsersAccountTypes'
import ShopOrders                                 from './pages/Shop/ShopOrders'
import ShopOrder                                  from './pages/Shop/ShopOrder'
import FranchiseDevelopmentDayPresentation        from './pages/static/FranchiseDevelopmentDayPresentation'
import Suppliers                                  from './pages/Suppliers/Suppliers'
import SuppliersFeedback                          from './pages/Suppliers/SuppliersFeedback'
import UserProfile                                from './pages/User/UserProfile'
import UserProfileEdit                            from './pages/User/UserProfileEdit'
import Users                                      from './pages/Users/Users'
import UsersAdd                                   from './pages/Users/UsersAdd'
import UsersEdit                                  from './pages/Users/UsersEdit'
import './App.css'

export default function App() {
  const currentUser = useSelector( state => state.currentUser.user )

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={ <Home /> } />

        <Route exact path="/bm-platform" element={ <BmPlatform /> } />
        <Route exact path="/bm-platform/faq" element={ <BmPlatformFaq /> } />
        <Route exact path="/bm-platform/help-centre" element={ <BmPlatformHelpCentre /> } />

        <Route exact path="/design-dock" element={ <DesignDock /> } />
        <Route exact path="/design-dock-error" element={ <DesignDockError /> } />

        <Route exact path="/documents/*" element={ <Documents /> } />

        <Route exact path="/downloads/*" element={ <DocumentsDownloadLog /> } />

        <Route exact path="/forum/add" element={ <CommunityForumNewThread /> } />
        <Route exact path="/forum/edit/:thread_id" element={ <CommunityForumEditThread /> } />
        <Route exact path="/forum/:thread_id" element={ <CommunityForumThread /> } />
        <Route exact path="/forum" element={ <CommunityForum /> } />

        <Route exact path="/franchise-development-day-presentation" element={ <FranchiseDevelopmentDayPresentation /> } />

        <Route exact path="/how-to-videos" element={ <HowToVideos /> } />

        <Route exact path="/locations/add" element={ <LocationsAdd /> } />
        <Route exact path="/locations/edit/:location_id" element={ <LocationsEdit /> } />
        <Route exact path="/locations" element={ <Locations /> } />

        <Route exact path="/login" element={ <Login /> } />

        <Route exact path="/new-senior-leader-notification" element={ <NewSeniorLeaderNotification /> } />

        <Route exact path="/nursery-support" element={ <NurserySupport /> } />

        <Route exact path="/password/reset" element={ <PasswordReset /> } />

        <Route exact path="/profile/edit" element={ <UserProfileEdit /> } />
        <Route exact path="/profile/:user_id" element={ <UserProfile /> } />
        <Route exact path="/profile" element={ <UserProfile /> } />

        <Route exact path="/regulatory-body-notification-form" element={ <RegulatoryBodyNotificationForm /> } />

        <Route exact path="/shop/orders" element={ <ShopOrders /> } />
        <Route exact path="/shop/order/:order_id" element={ <ShopOrder /> } />
        <Route path="/shop/*" element={ <Navigate to="/404" /> } />

        <Route exact path="/settings" element={ <Settings /> } />
        <Route exact path="/settings/dashboard/banner" element={ <SettingsDashboardBanner /> } />
        <Route exact path="/settings/users/account-types" element={ <SettingsUsersAccountTypes /> } />
        <Route exact path="/settings/forum/categories" element={ <SettingsForumCategories /> } />
        <Route exact path="/settings/forum/ranks" element={ <SettingsForumRanks /> } />
        <Route exact path="/settings/forum/ranks/add" element={ <SettingsForumRank /> } />
        <Route exact path="/settings/forum/ranks/edit/:rank_id" element={ <SettingsForumRank /> } />
        <Route exact path="/settings/shop/categories" element={ <SettingsShopCategories /> } />
        <Route exact path="/settings/shop/delivery-options" element={ <SettingsShopDeliveryOptionsList /> } />
        <Route exact path="/settings/shop/delivery-options/add" element={ <SettingsShopDeliveryOption /> } />
        <Route exact path="/settings/shop/delivery-options/edit/:delivery_option_id" element={ <SettingsShopDeliveryOption /> } />
        <Route exact path="/settings/shop/size-guides" element={ <SettingsShopSizeGuidesList /> } />
        <Route exact path="/settings/shop/size-guides/add" element={ <SettingsShopSizeGuide /> } />
        <Route exact path="/settings/shop/size-guides/edit/:size_guide_id" element={ <SettingsShopSizeGuide /> } />
        <Route exact path="/settings/shop/products" element={ <SettingsShopProductsList /> } />
        <Route exact path="/settings/shop/products/add" element={ <SettingsShopProduct /> } />
        <Route exact path="/settings/shop/products/edit/:product_id" element={ <SettingsShopProduct /> } />
        <Route exact path="/settings/shop/variants" element={ <SettingsShopVariants /> } />
        <Route exact path="/settings/shop/variants-variations" element={ <SettingsShopVariantsVariations /> } />

        <Route exact path="/suppliers" element={ <Suppliers /> } />
        <Route exact path="/suppliers/feedback" element={ <SuppliersFeedback /> } />

        <Route exact path="/users/add" element={ <UsersAdd /> } />
        <Route exact path="/users/edit/:user_id" element={ <UsersEdit /> } />
        <Route exact path="/users" element={ <Users /> } />

        <Route path="*" element={ <Navigate to="/404" /> } />

        <Route path="/404" element={ <FourFour /> } />
      </Routes>
    </BrowserRouter>
  )
}
